import { createContext, useContext } from "react"

import type { AdrIncidentRecord } from "@/api/useIncidents.types"

export const getInitialState = () => ({
  incidents: [] as AdrIncidentRecord[],
  rules: {} as Record<string, number>,
  environments: {} as Record<string, number>,
  details: false,
  toggleDetails: () => {}
})

export const DataContext = createContext(getInitialState())

export const useDataContext = () => useContext(DataContext)
